import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';
import { useFormSubmission } from '../hooks/useApi';

const ContactSection: React.FC = () => {
  const { loading, error, success, submitContact, reset } = useFormSubmission();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await submitContact(formData);
    if (success) {
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
    }
  };

  const contactInfo = {
    phone: '+91 98765 43210',
    email: 'info@laxmimotors.com',
    address: 'Limbodi, Indore, Madhya Pradesh 452001',
    hours: 'Mon-Sat: 9:00 AM - 7:00 PM, Sun: 10:00 AM - 5:00 PM'
  };

  return (
    <section id="contact" className="py-5">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Get In Touch</h2>
          <p className="lead text-muted">
            Ready to service your vehicle? Contact us today for expert automobile care
          </p>
        </div>

        <Row>
          <Col lg={6} className="mb-4">
            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-primary text-white rounded-circle p-3 me-3">
                    📞
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Phone Number</h6>
                    <p className="text-muted mb-0">{contactInfo.phone}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-success text-white rounded-circle p-3 me-3">
                    ✉️
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Email Address</h6>
                    <p className="text-muted mb-0">{contactInfo.email}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-warning text-white rounded-circle p-3 me-3">
                    📍
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Our Location</h6>
                    <p className="text-muted mb-0">{contactInfo.address}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="bg-info text-white rounded-circle p-3 me-3">
                    🕰️
                  </div>
                  <div>
                    <h6 className="fw-bold mb-1">Working Hours</h6>
                    <p className="text-muted mb-0">{contactInfo.hours}</p>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <h4 className="fw-bold mb-4">Send us a Message</h4>
                
                {success && (
                  <Alert variant="success">
                    Thank you! Your message has been sent successfully.
                  </Alert>
                )}
                
                {error && (
                  <Alert variant="danger">
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone *</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Email *</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label>Message *</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                  
                  <div className="d-flex gap-3">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      className="flex-fill"
                      disabled={loading}
                    >
                      {loading ? 'Sending...' : 'Send Message'}
                    </Button>
                    <Button 
                      variant="warning" 
                      href={`tel:${contactInfo.phone}`}
                      as="a"
                      className="flex-fill"
                    >
                      📞 Call Now
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactSection;